"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchTime = void 0;
const MAX_VALUE = 2147483647;
const getSearchTime = timestamp => {
  const searchTime = Date.now() - timestamp;
  return searchTime > 0 && searchTime <= MAX_VALUE ? searchTime : 0;
};
exports.getSearchTime = getSearchTime;
